/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".timer[_ngcontent-%COMP%]{font-size:1em;letter-spacing:-1px}.timer[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:1.2em;margin:0 3px;font-weight:400}"];
export { styles as styles };
